import { Controller } from "@hotwired/stimulus";
import { Datepicker } from "vanillajs-datepicker";
import { DateTime } from "luxon";
import { DatepickerOptions } from "vanillajs-datepicker/Datepicker";

export default class extends Controller<HTMLInputElement> {
  static readonly values = {
    dateHiddenFieldName: String,
  };

  declare readonly dateHiddenFieldNameValue: string;
  declare readonly hasDateHiddenFieldNameValue: boolean;

  private _dateHiddenFieldInput: HTMLInputElement | null = null;

  private _datepicker: Datepicker | null = null;
  private readonly _options: DatepickerOptions = {
    clearButton: true,
    format: {
      toValue: (date) => {
        const luxonDate = DateTime.fromFormat(date, "yyyy-MM-dd");
        return luxonDate.toJSDate().getTime();
      },
      toDisplay(date) {
        const luxonDate = DateTime.fromJSDate(date);
        return luxonDate.toFormat("dd/MM/yyyy");
      },
    },
  };

  private _onDateChange: (event: Event) => void;

  connect(): void {
    this._getDateHiddenField();

    this._datepicker = new Datepicker(this.element, this._options);

    this._registerUpdateDateHiddenFieldOnDateChange();
  }

  disconnect(): void {
    this.element.removeEventListener("changeDate", this._onDateChange);
    this._datepicker?.destroy();
  }

  private _getDateHiddenField() {
    if (this.hasDateHiddenFieldNameValue) {
      this._dateHiddenFieldInput = document.querySelector(
        `input[name="${this.dateHiddenFieldNameValue}"]`
      );
      if (this._dateHiddenFieldInput) {
        this.element.value = this._dateHiddenFieldInput.value;
      }
    }
  }

  private _registerUpdateDateHiddenFieldOnDateChange() {
    if (this._dateHiddenFieldInput) {
      this._onDateChange = this._updateDateHiddenField.bind(this);
      this.element.addEventListener("changeDate", this._onDateChange);
    }
  }

  private _updateDateHiddenField(event: CustomEvent) {
    if (this._dateHiddenFieldInput) {
      const date = event.detail.date;

      if (date === undefined) {
        this._dateHiddenFieldInput.value = "";
        return;
      }

      if (date instanceof Date) {
        const luxonDate = DateTime.fromJSDate(date);
        this._dateHiddenFieldInput.value = luxonDate.toFormat("yyyy-MM-dd");
      }
    }
  }
}
